// extracted by mini-css-extract-plugin
export default {"backdrop":"VideoModal_backdrop__9w1iq","modal":"VideoModal_modal__vJAr+","appear":"VideoModal_appear__Hbjzf","footer":"VideoModal_footer__VZL92"};